import { render, staticRenderFns } from "./MarkingRuleConfig.vue?vue&type=template&id=10a4651e&scoped=true"
import script from "./MarkingRuleConfig.vue?vue&type=script&lang=js"
export * from "./MarkingRuleConfig.vue?vue&type=script&lang=js"
import style0 from "./MarkingRuleConfig.vue?vue&type=style&index=0&id=10a4651e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a4651e",
  null
  
)

export default component.exports